var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon-btn',_vm._g(_vm._b({staticClass:"ma-2",attrs:{"icon":"mdi-close"}},'app-icon-btn',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }